import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {PlaygroundProductType} from '../../model/playground.model';

@Component({
  selector: 'playground-allocation-dialog',
  templateUrl: './playground-allocation-dialog.component.html',
  standalone: false
})
export class PlaygroundAllocationDialogComponent implements OnInit {
  @Input() salesOrderId!: number;
  @Input() productTypes: PlaygroundProductType[] = [];

  form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<PlaygroundAllocationDialogComponent>
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      productTypeId: [null],
      vendorName: [''],
      subVendorId: [null],
      subVendorName: [''],
      amount: [null],
      amountUSD: [null],
      currencyCode: ['USD'],
      vendorReference: ['']
    });
  }

  save(): void {
    if (this.form.valid) {
      const val = this.form.value;
      this.dialogRef.close({
        salesOrderId: this.salesOrderId,
        ...val
      });
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
